import React, { useEffect, useState } from "react";
import {
  getDatabase,
  onValue,
  push,
  ref,
  set,
} from "firebase/database";

const NewOrder = () => {
  const db = getDatabase();

  const [transporters, setTransporters] = useState([]);
  const [clients, setClients] = useState([]);

  const [formData, setFormData] = useState({
    clientName: "",
    transporterName: "",
    transporterPhone: "",
    fromAddress: "",
    toAddress: "",
    quantity: "",
    quantityUnit: "Bags",
    addToRoutes: false,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const transportRef = ref(db, "transporter-profile");

    onValue(transportRef, (snapshot) => {
      const data = snapshot.val();

      if (!data) {
        setTransporters([]);
        return;
      }

      const transporterList = Object.keys(data).map((key) => ({
        id: key,
        company:
          data[key]?.company ||
          data[key]?.contactPerson ||
          "",
        phone: data[key]?.phone || "",
      }));

      setTransporters(transporterList);
    });

    const clientRef = ref(db, "profileDashboard");

    onValue(clientRef, (snapshot) => {
      const data = snapshot.val();

      if (!data) {
        setClients([]);
        return;
      }

      const clientList = Object.keys(data).map((key) => ({
        id: key,
        company_name: data[key]?.company_name || "",
      }));

      setClients(clientList);
    });
  }, [db]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleTransporterSelect = (value) => {
    const selectedTransporter = transporters.find(
      (item) => item.company === value
    );

    setFormData((prev) => ({
      ...prev,
      transporterName: value,
      transporterPhone: selectedTransporter?.phone || "",
    }));
  };

  const submitOrder = async () => {
    try {
      setLoading(true);

      const selectedTransporter = transporters.find(
        (item) => item.company === formData.transporterName
      );

      const selectedClient = clients.find(
        (item) => item.company_name === formData.clientName
      );

      if (!selectedTransporter?.id) {
        alert("Please select a valid transporter");
        setLoading(false);
        return;
      }

      const requestRef = push(
        ref(
          db,
          `transport_requests/${selectedTransporter.id}/`
        )
      );

      await set(requestRef, {
        clientId: selectedClient?.id || "",
        clientName: formData.clientName,
        transporterId: selectedTransporter.id,
        transporterName: formData.transporterName,
        transporterPhone: formData.transporterPhone,
        from: formData.fromAddress,
        to: formData.toAddress,
        quantity: formData.quantity,
        quantityUnit: formData.quantityUnit,
        createdAt: Date.now(),
        status: "waiting for response",
      });

      if (formData.addToRoutes) {
        const routeRef = push(ref(db, "transport-routes"));

        await set(routeRef, {
          from: formData.fromAddress,
          to: formData.toAddress,
          createdAt: Date.now(),
        });
      }

      alert("Transport request created successfully");

      setFormData({
        clientName: "",
        transporterName: "",
        transporterPhone: "",
        fromAddress: "",
        toAddress: "",
        quantity: "",
        quantityUnit: "Bags",
        addToRoutes: false,
      });
    } catch (error) {
      console.log(error);
      alert("Failed to create transport request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.formContainer}>
        <div style={styles.headerSection}>
          <h1 style={styles.heading}>Create New Order</h1>
          <p style={styles.subHeading}>
            Logistics transport request creation panel
          </p>
        </div>

        {/* CLIENT + TRANSPORTER */}
        <div style={styles.formRow}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Client Name</label>

            <input
              list="clients-list"
              placeholder="Select or enter client"
              value={formData.clientName}
              onChange={(e) =>
                handleChange("clientName", e.target.value)
              }
              style={styles.input}
            />

            <datalist id="clients-list">
              {clients.map((client) => (
                <option
                  key={client.id}
                  value={client.company_name}
                />
              ))}
            </datalist>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Transporter</label>

            <input
              list="transporters-list"
              placeholder="Select or enter transporter"
              value={formData.transporterName}
              onChange={(e) =>
                handleTransporterSelect(e.target.value)
              }
              style={styles.input}
            />

            <datalist id="transporters-list">
              {transporters.map((item) => (
                <option
                  key={item.id}
                  value={item.company}
                >
                  {item.phone}
                </option>
              ))}
            </datalist>
          </div>
        </div>

        {/* FROM TO */}
        <div style={styles.formRow}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>From Address</label>

            <input
              type="text"
              placeholder="Pickup location"
              value={formData.fromAddress}
              onChange={(e) =>
                handleChange("fromAddress", e.target.value)
              }
              style={styles.input}
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>To Address</label>

            <input
              type="text"
              placeholder="Delivery location"
              value={formData.toAddress}
              onChange={(e) =>
                handleChange("toAddress", e.target.value)
              }
              style={styles.input}
            />
          </div>
        </div>

        {/* ROUTE SAVE */}
        <div style={styles.routeSaveBar}>
          <div>
            <p style={styles.routeTitle}>Save Route</p>
            <span style={styles.routeText}>
              Add this route into transport-routes database node
            </span>
          </div>

          <button
            type="button"
            onClick={() =>
              handleChange("addToRoutes", !formData.addToRoutes)
            }
            style={{
              ...styles.routeButton,
              background: formData.addToRoutes
                ? "#16a34a"
                : "#e2e8f0",
              color: formData.addToRoutes
                ? "white"
                : "#0f172a",
            }}
          >
            {formData.addToRoutes ? "✓ Added" : "Add To Routes"}
          </button>
        </div>

        {/* QUANTITY */}
        <div style={styles.formRow}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Cement Quantity</label>

            <input
              type="number"
              placeholder="Enter quantity"
              value={formData.quantity}
              onChange={(e) =>
                handleChange("quantity", e.target.value)
              }
              style={styles.input}
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Unit Type</label>

            <div style={styles.toggleWrapper}>
              <button
                type="button"
                onClick={() =>
                  handleChange("quantityUnit", "Bags")
                }
                style={{
                  ...styles.toggleButton,
                  background:
                    formData.quantityUnit === "Bags"
                      ? "#2563eb"
                      : "#f1f5f9",
                  color:
                    formData.quantityUnit === "Bags"
                      ? "white"
                      : "#0f172a",
                }}
              >
                Bags
              </button>

              <button
                type="button"
                onClick={() =>
                  handleChange("quantityUnit", "MT")
                }
                style={{
                  ...styles.toggleButton,
                  background:
                    formData.quantityUnit === "MT"
                      ? "#2563eb"
                      : "#f1f5f9",
                  color:
                    formData.quantityUnit === "MT"
                      ? "white"
                      : "#0f172a",
                }}
              >
                MT
              </button>
            </div>
          </div>
        </div>

        {/* SUBMIT */}
        <div style={styles.submitSection}>
          <button
            onClick={submitOrder}
            disabled={loading}
            style={styles.submitButton}
          >
            {loading ? "Submitting..." : "Create Transport Request"}
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageWrapper: {
    width: "100%",
    padding: "24px",
    background: "#f8fafc",
    minHeight: "100vh",
    boxSizing: "border-box",
  },

  formContainer: {
    width: "100%",
    background: "white",
    borderRadius: "24px",
    border: "1px solid #e2e8f0",
    padding: "28px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    boxSizing: "border-box",
  },

  headerSection: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },

  heading: {
    margin: 0,
    fontSize: "30px",
    color: "#0f172a",
    fontWeight: 700,
  },

  subHeading: {
    margin: 0,
    color: "#64748b",
    fontSize: "14px",
  },

  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },

  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  label: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
  },

  input: {
    height: "52px",
    borderRadius: "14px",
    border: "1px solid #cbd5e1",
    padding: "0 16px",
    fontSize: "14px",
    outline: "none",
    background: "white",
  },

  routeSaveBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #dbe3ef",
    background: "#f8fafc",
    borderRadius: "18px",
    padding: "18px",
    gap: "20px",
  },

  routeTitle: {
    margin: 0,
    fontSize: "15px",
    fontWeight: 600,
    color: "#0f172a",
  },

  routeText: {
    color: "#64748b",
    fontSize: "13px",
  },

  routeButton: {
    border: "none",
    borderRadius: "12px",
    padding: "12px 18px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "14px",
  },

  toggleWrapper: {
    display: "flex",
    gap: "12px",
  },

  toggleButton: {
    flex: 1,
    border: "none",
    borderRadius: "14px",
    height: "52px",
    fontWeight: 600,
    cursor: "pointer",
    fontSize: "14px",
  },

  submitSection: {
    display: "flex",
    justifyContent: "flex-end",
  },

  submitButton: {
    border: "none",
    background: "#2563eb",
    color: "white",
    height: "52px",
    borderRadius: "14px",
    padding: "0 28px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "14px",
  },
};

export default NewOrder;
